module.exports = __webpack_public_path__ + "static/media/orders-shot-2.f0eac49c.png";